
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////	EVENT HANDLERS //////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


/////////////////////////////////////////////////////////// HANDLER FOR PAGE SCROLL /////////////////////////////////////////////////

document.addEventListener('DOMContentLoaded', () => {
	
	const pageHeader = new Header("header");
	
	if (pageHeader.headerDomEl.classList.contains("header_shrinkingOnScroll"))
		{
		document.addEventListener("scroll", () => {
				
				pageHeader.dynamicHeaderResize();
				
			});
		}
		
	const dropDownParentPage_a = pageHeader.headerDomEl.querySelectorAll('.navBar__dropDownMenu');
	
	if (!dropDownParentPage_a) return;
	
	dropDownParentPage_a.forEach( (page, ind) => {
		
		pageHeader.dropDownParentPages.push(page);
		var pageName = page.querySelector('.navBar__navLink').getAttribute('href').replace('.html', '');
console.log("pageName = " + pageName);
		pageHeader.dropDownButtons.push(page.querySelector(`.dropDownMenu__button_${pageName}`));
		pageHeader.dropDownMenus.push(page.querySelector(`.dropDownMenu__table_${pageName}`));
	})
console.log("pageHeader.dropDownButtons = " + pageHeader.dropDownButtons);	

	document.addEventListener("click", (ev) => {
				pageHeader.toggleDropdown(ev);
			})

});

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////// CLASSES DEFINITIONS //////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

class Header {
	constructor(headerSelector) {
		this.headerDomEl = document.querySelector(headerSelector);
		this.dropDownParentPages = [];
		this.dropDownButtons = [];
		this.dropDownMenus = [];
	}
	
	dynamicHeaderResize() {

//console.log(this.headerDomEl);
			let header_children = this.headerDomEl.querySelectorAll(".sticky_header>div");
			
			let navBar = this.headerDomEl.querySelector("nav");
//console.log("navBar = " + navBar);
//console.log("header_children = " + header_children);
			
			let headerDivNum = header_children.length;

			let LastKnownPos = window.scrollY;
				
				if (LastKnownPos >= 200)
					{ 
						header_children.forEach( (child) => {
							child.style.display="none";
						})
						
					navBar.style.height = "max-content";
					navBar.style.paddingTop = "1vmin";
					navBar.style.paddingBottom = "1vmin";
					navBar.minHeight = "max-content";
						
					}
					
					if (LastKnownPos <= 10)
						{
							header_children.forEach( (child) => {
								child.style.display = "revert-layer";
							})
							
						navBar.style.paddingTop = "initial";
						navBar.style.paddingBottom = "initial";
						header_children[1].style.display = "revert-layer";
						header_children[1].style.alignItems = "center";

						this.headerDomEl.style.minHeight="initial";
						}		
//console.log(navBar.style);
//console.log(header_children[1].style);
//console.log(header_children[1].style.display);

	}

	toggleDropdown(clickEvent) {
					
					this.dropDownParentPages.forEach( (page, ind) => {
/* console.log("page.innerHTML = " + page.innerHTML);					 */
						let pageName = page.querySelector('.navBar__navLink')?.getAttribute('href')?.replace('.html','');
console.log("pageName = " + pageName);						
						if ( clickEvent.target.classList.contains(`dropDownMenu__button_${pageName}`) )
							{
								let dropdownLinkBoxHeight = window.getComputedStyle(page).getPropertyValue('height');
								
								this.dropDownMenus[ind].style.setProperty("top", `${dropdownLinkBoxHeight}`);
								
								this.dropDownMenus[ind].classList.toggle(`dropDownMenu__table_${pageName}_show`);
								
								let dropDownButton = this.dropDownButtons[ind];
								
								let buttonArrowRotation = window.getComputedStyle(dropDownButton).getPropertyValue("--dropDownMenuButtonRotation");
								
								if (buttonArrowRotation === "90deg")
									{
									this.dropDownButtons[ind].style.setProperty("--dropDownMenuButtonRotation", "-90deg");
									this.dropDownButtons[ind].style.setProperty("--dropDownMenuButtonYTranslation", "-25%");
									}
								else
									{
									this.dropDownButtons[ind].style.setProperty("--dropDownMenuButtonRotation", "90deg");
									this.dropDownButtons[ind].style.setProperty("--dropDownMenuButtonYTranslation", "25%");
									}
							}
						else 
							{
								this.dropDownMenus[ind].classList.remove(`dropDownMenu__table_${pageName}_show`);
								
								this.dropDownButtons[ind].style.setProperty("--dropDownMenuButtonRotation", "90deg");
								this.dropDownButtons[ind].style.setProperty("--dropDownMenuButtonYTranslation", "25%");
							}
//console.log("this.dropDownMenus[ind].classList = " + this.dropDownMenus[ind].classList);
					});
//console.log(this.dropDownButtons[0])
//console.log(this.dropDownMenus[0])
//console.log("dropdownLinkBoxHeight = " + dropdownLinkBoxHeight)

	}
}
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////